module.exports = __webpack_public_path__ + "static/media/9DESA13.4b0020e4.jpg";